import { render } from "./new-category.vue?vue&type=template&id=5b4ca906"
import script from "./new-category.vue?vue&type=script&lang=js"
export * from "./new-category.vue?vue&type=script&lang=js"

import "./new-category.vue?vue&type=style&index=0&id=5b4ca906&lang=scss"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__